import Repo from './Repo.js'

export default class ScheduledOvertimeRepository extends Repo {
  constructor () {
    super('scheduled-overtimes')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  syncUsers(id, data){
    data.include = "sectors";
    return this.http.post(this.resource + '/' + id + '/users/sync', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  decisionPdf (id, data, name = "Decision") {
    return this.http.download(this.resource + "/" + id + "/decision", data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/pdf' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.pdf';
      link.click();
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  resolutionPdf (id, data, name = "Resolution") {
    return this.http.download(this.resource + "/" + id + "/resolution", data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/pdf' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.pdf';
      link.click();
      return Promise.resolve(response);
    }).catch((response) =>{
      return Promise.reject(response);
    });
  }

  search (data) {
    return this.http.get(this.resource + '/search', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  searchAndExport (data, name = "Izveštaj Prekovremeni rad") {
    data.export = 1;
    return this.http.download(this.resource + '/search', data).then((response) => {
      let blob = new Blob([response.data], { type:   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' } );
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name+'.xlsx';
      link.click();
      return Promise.resolve(response);
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

}
